import { cn } from "@/lib/utils";

const LOGO_SRC = `${process.env.PUBLIC_URL || ""}/ameya-logo.jpg`;

/** GSTDesk brand lockup — the real Ameya Management Group mark + product wordmark. */
export function Logo({ size = 36, withText = true, subtitle, className = "" }) {
  return (
    <div className={cn("flex items-center gap-2.5", className)}>
      <div
        className="rounded-xl bg-white flex items-center justify-center p-1.5 ring-1 ring-black/10 shadow-sm shrink-0"
        style={{ width: size, height: size }}
      >
        <img src={LOGO_SRC} alt="Ameya Management Group" className="w-full h-full object-contain rounded-lg" />
      </div>
      {withText && (
        <div className="leading-none">
          <div className="font-head text-xl font-bold tracking-tight">
            GST<span className="text-indigo-400">Desk</span>
          </div>
          {subtitle && <div className="text-xs text-muted-foreground mt-1.5 font-medium tracking-wide">{subtitle}</div>}
        </div>
      )}
    </div>
  );
}

